var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "instafeed" },
    [
      _c("p", { staticClass: "username" }, [
        _c("a", { attrs: { href: _vm.userpage, target: "_blank" } }, [
          _vm._v(_vm._s(this.username))
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.data, function(item) {
        return _c(
          "a",
          {
            key: item.id,
            staticClass: "item",
            attrs: { href: _vm.userpage, target: "_blank" }
          },
          [
            _c("div", {
              staticClass: "img-wrapper",
              style: {
                backgroundImage:
                  "url(" + item.images.standard_resolution.url + ")"
              }
            })
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }